import { ReactNode } from "react";
import { cn } from "@volca/ui/lib/utils";

interface BusinessSettingsSidebarWrapperProps {
  children: ReactNode;
  className?: string;
}

export const BusinessSettingsSidebarWrapper = ({
  children,
  className = "",
}: BusinessSettingsSidebarWrapperProps) => (
  <div className={cn("flex h-full flex-col overflow-hidden", className)}>
    {children}
  </div>
);
